"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  accentFill: {
    fill: theme.palette.primary.main
  }
}));
const SingleIcon = props => {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 310 110",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Railway_Layout_1_",
      opacity: "0.25",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "41.325",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "153.9",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_3",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "266.476",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Track",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            y: "47.657",
            fillRule: "evenodd",
            clipRule: "evenodd",
            width: "310",
            height: "13.509"
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Single_1_",
      className: classes.accentFill,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Shape_4_copy_2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fillRule: "evenodd",
            fill: "primary",
            clipRule: "evenodd",
            points: "267.039,21.398 229.93,-0.026 229.93,12.575 43.854,12.575 43.854,30.218 229.93,30.218 229.93,42.821"
          })
        })
      })
    })]
  });
};
var _default = exports.default = SingleIcon;